import { Box, Button, Grid, Typography } from "@mui/material";

import { PRODUCT_STATUSES } from "api/memberPortal/project/product/productStatuses.type";
import { useAuth } from "hooks/useAuth";

export default function AddEvalTeamSection({
  productForm,
  product_id,
}: {
  productForm: any;
  product_id: number;
}) {
  const { permissions } = useAuth();

  const hasRequiredPermissions =
    permissions?.role_permissions?.find(
      (permission) => permission.area === "Project Members",
    )?.update &&
    permissions?.role_permissions?.find(
      (permission) => permission.area === "Evaluation Team",
    )?.create;

  if (!hasRequiredPermissions) return null;

  return (
    <>
      <Box className="mb-4">
        {/* WARN: Custom styling from pre standardization! */}
        {/* TODO: Standardize when you come across this!  */}
        <Typography variant="body1" className="mb-2">
          EVALUATION TEAM
        </Typography>
        <div className="border p-3 rounded">
          {/* WARN: Custom styling from pre standardization! */}
          {/* TODO: Standardize when you come across this!  */}
          <Typography
            variant="body1"
            className="mb-3"
            sx={{ color: "text.secondary" }}
          >
            Add Members to Evaluation Team?
          </Typography>
          <Grid container spacing={3}>
            <Grid item xs={12} md={6}>
              <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => {
                    productForm.reset({
                      ...productForm.state.values,
                      switchForm: true,
                      status: PRODUCT_STATUSES.DRAFT,
                      formState: `draft-${product_id ? "update" : "create"}`,
                    });
                    productForm.handleSubmit();
                  }}
                >
                  Click to add Evaluation Team Members
                </Button>
                {/* WARN: Custom styling from pre standardization! */}
                {/* TODO: Standardize when you come across this!  */}
                <Typography variant="body2" fontWeight="bold" className="mb-1">
                  (Note: Clicking this button will save this form as a Draft)
                </Typography>
                {/* WARN: Custom styling from pre standardization! */}
                {/* TODO: Standardize when you come across this!  */}
                <Typography
                  variant="body2"
                  color="text.secondary"
                  fontStyle="italic"
                >
                  Lead Evaluator Assignment Required to Submit Form
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </div>
      </Box>
    </>
  );
}
